import moment from "moment";
import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchExpenseSummary = createAsyncThunk("fetchExpenseSummary", async ({ page, limit, filters }) => {
	let start_date = "";
	let end_date = "";

	if (filters?.range?.length === 2) {
		start_date = moment(filters.range[0].$d).format("YYYY-MM-DD");
		end_date = moment(filters.range[1].$d).format("YYYY-MM-DD");
	}
	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
		company_id: filters?.company_id ?? "",
		category_id: filters?.category_id ?? "",
		department_id: filters?.department_id ?? "",
		status_id: filters?.status_id ?? "",
		start_date: start_date ?? "",
		end_date: end_date ?? "",
	});

	const response = await axiosHttp.get(`expense?${params}`);
	return response.data.data;
});

const ExpenseSummarySlice = createSlice({
	name: "ExpenseSummarySlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchExpenseSummary.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchExpenseSummary.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.pagination?.page;
			state.total = action.payload.pagination?.total;
		});
		builder.addCase(fetchExpenseSummary.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ExpenseSummarySlice.reducer;
